import { isArray } from 'util';
import { mapCollection, sortByString } from '../../utils/collection.utils';
import { PaymentMethod } from '../payment-method';

export class PaymentMethodBuilder {

  static fromJson(json): PaymentMethod {
    return (json) ? new PaymentMethod(
      json.hash,
      json.name,
      json.description
    ) : null;
  }

  static fromJsonList(list): PaymentMethod[] {
    return (isArray(list)) ? sortByString('name', mapCollection(PaymentMethodBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/payment-method-builder.ts